import { render, staticRenderFns } from "./RespondSurveySuccess.vue?vue&type=template&id=3b850fc0&scoped=true&"
import script from "./RespondSurveySuccess.vue?vue&type=script&lang=js&"
export * from "./RespondSurveySuccess.vue?vue&type=script&lang=js&"
import style0 from "./RespondSurveySuccess.vue?vue&type=style&index=0&id=3b850fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b850fc0",
  null
  
)

export default component.exports